import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { DateRangeDisplay } from "@components/settings/OrganizationCloseTemplates/DateRangeDisplay";
import { ClientsWorkOverviewRow } from "../clientsWorkOverviewViewConfig";
import { EMPTY_CELL_VALUE } from "./emptyCellValue";

export const WorkServicePeriodCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, ClientsWorkOverviewRow, unknown>) => {
        if (row.original.rowType !== "work") {
            return EMPTY_CELL_VALUE;
        }
        const { startDate, endDate } = row.original;
        if (!startDate && !endDate) {
            return EMPTY_CELL_VALUE;
        }
        return <DateRangeDisplay startDate={startDate} endDate={endDate} />;
    },
);
WorkServicePeriodCell.displayName = "WorkServicePeriodCell";
